"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.FestivalSuccessCommand = void 0;
class FestivalSuccessCommand {
    constructor(input) {
        this.input = input;
    }
    execute(config) {
        const { event_id, event_name, event_region_id, activities } = this.input;
        const { gtag: googleAnalyst } = config;
        googleAnalyst('event', 'festival_success', {
            event_id,
            event_name,
            event_region_id,
            activities: activities?.map(a => ({
                activity_code: a.activity_code,
                activity_name: a.activity_name,
            })) ?? [],
        });
        return Promise.resolve();
    }
}
exports.FestivalSuccessCommand = FestivalSuccessCommand;
